import React, { useEffect, useMemo } from "react";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
} from "../../common_components/common_widgets/popup";
import MdaeButton from "../../common_components/common_widgets/button";
import { useDispatch, useSelector } from "react-redux";
import { TOGGLE_TASK_HISTORY_POPUP } from "./reducers/user-task-list-reducer";
import ExternalAuditHistory from "../../pages/external-audit/external-audit-history";
import { isEqual } from "lodash";
import { GET_EXTERNAL_AUDIT_HISTORY } from "../../pages/external-audit/services/get-external-audit-history";
import { bindActionCreators } from "redux";
import {  actions as asyncActions } from "async-ops";

export const toggleTaskHistoryPopup = (isVisible, dispatch, taskHistoryRefTaskName="") => {
  dispatch({
    type: TOGGLE_TASK_HISTORY_POPUP,
    data: {
      isTaskHistoryPopupVisible: isVisible,
      taskHistoryRefTaskName
    },
  });
}


const TaskHistoryPopup=() => {
  const dispatch = useDispatch();
  const taskHistoryRefTaskName = useSelector(
    (state: any) => state["userTaskListReducer"].taskHistoryRefTaskName,
    isEqual
  );
  const isTaskHistoryPopupVisible = useSelector(
    (state: any) => state["userTaskListReducer"].isTaskHistoryPopupVisible,
    isEqual
  );
  const userTaskFormData = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskFormData,
    isEqual
  );
  const asyncAction = useMemo(
    () =>
      bindActionCreators(
        {
          asyncOperationStart: asyncActions.asyncOperationStart,
        },
        dispatch
      ),
    [dispatch]
  );

  useEffect(() => {
    if(userTaskFormData?.auditId>0 &&userTaskFormData.userTaskId){
      asyncAction.asyncOperationStart(GET_EXTERNAL_AUDIT_HISTORY, {
        eaAuditId: userTaskFormData.auditId,
        userTaskId:userTaskFormData.userTaskId
      });
    }
  }, [userTaskFormData.userTaskId,userTaskFormData.auditId]);

  const getPopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          toggleTaskHistoryPopup(false, dispatch);
        }}
      >
        Task History {taskHistoryRefTaskName ? `(${taskHistoryRefTaskName})` :''}
      </MdaePopupTitle>
    );
  };
  const mdaeDataUpdaterConfig = useMemo(
    () => [
      {
        actionType: TOGGLE_TASK_HISTORY_POPUP,
        reducerName: "userTaskListReducer",
        widgetOptionBindings: {
          visible: "isTaskHistoryPopupVisible",
        },
      },
    ],
    [] 
  );
  return (
    <div>
      <MdaePopup
        deferRendering={false}
        width="1000px"
        height="700px"
        className="task-history-popup"
        mdaeTitleRender={getPopupTitle}
        visible={isTaskHistoryPopupVisible}
        mdaeDataUpdaterConfig={mdaeDataUpdaterConfig}
        mdaeContentRender={() => {
          return (
            <div>
              <MdaePopupContent>
                <div className="task-history-grid">
                    <ExternalAuditHistory showInPopup={true}
                    />
                </div>
              </MdaePopupContent>
            </div>
          )
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"pnlCloseTaskHistoryPopup"}
                  role={"primary"}
                  onClick={() => {
                    toggleTaskHistoryPopup(false, dispatch);
                  }}
                >
                  Close
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          )
        }}
      >

      </MdaePopup>
    </div>
  )

}

export default TaskHistoryPopup;